import React from 'react';

import styles from './BadgeTopCleaner.module.scss';
import crown from '../../constants/images/crown.svg';

const BadgeTopCleaner = () => {
    return (
        <div className={styles.badge}>
            <img src={crown} alt="crown"/>
            <p className={styles.badge_role}>Top Cleaner</p>
        </div>
    );
};

export default BadgeTopCleaner;
